import { useQuery } from 'react-query';

import userService from 'resources/user/user.service';
import dealService from 'resources/deal/deal.service';

import * as userHelpers from 'resources/user/user.helpers';

export const getCompanyClients = async (companyId, userId, excludeDeals = false) => {
  const clients = await userService.getCompanyClients(companyId) || [];
  const companyDeals = await dealService.getDealsByCompanyId(companyId) || [];

  const filteredClients = userHelpers.filterSampleClients({
    clients,
    realtorId: userId,
    deals: companyDeals,
  });

  if (excludeDeals) {
    return filteredClients;
  }

  const promises = filteredClients.map(async (client) => {
    const deals = await dealService.getDealsByClientId(client.id) || [];

    return { ...client, deals };
  });

  const clientsWithDeals = await Promise.all(promises);

  return clientsWithDeals;
};

export default function useCompanyClients(companyId, userId, {
  excludeDeals = false,
  ...queryOptions
} = {}) {
  return useQuery(
    ['users.getCompanyClients', companyId, userId],
    () => getCompanyClients(companyId, userId, excludeDeals),
    queryOptions,
  );
}
